import InputTypeEditor from './InputTypeEditor';

export default InputTypeEditor;
